import { PHONE_REGEX, EMAIL_REGEX } from "constants/regex";

/**
 * Validates an email address against a predefined regex pattern.
 *
 * @param {string} email - The email address to be validated.
 * @returns { isError: boolean; errorMessage: string }} - Returns true if the email address matches the regex pattern, false otherwise.
 */
export const emailValidation = (
  email: string
): { isError: boolean; errorMessage: string } => {
  if (!email) {
    return {
      isError: true,
      errorMessage: "Email address is required.",
    };
  }
  if (email.length < 5) {
    return {
      isError: true,
      errorMessage: "Email address must be at least 5 characters long.",
    };
  }

  const value = EMAIL_REGEX.test(email);
  if (!value) {
    return {
      isError: true,
      errorMessage: "Please Enter Valid Email Address",
    };
  }

  return {
    isError: false,
    errorMessage: "",
  };
};

/**
 * Validates a phone number against a predefined regex pattern.
 *
 * @param {string | number} phone - The phone number to be validated. Can be a string or a number.
 * @returns {boolean} - Returns { isError: boolean; errorMessage: string }  if the phone number matches the regex pattern, false otherwise.
 */
export const phoneValidation = (
  phone: string | number
): { isError: boolean; errorMessage: string } => {
  if (!phone) {
    return {
      isError: true,
      errorMessage: "Phone number is required.",
    };
  }
  if (phone?.toString().length < 10) {
    return {
      isError: true,
      errorMessage: "Phone number must be at least 10 digits long.",
    };
  }
  if (phone?.toString().length > 15) {
    return {
      isError: true,
      errorMessage: "Phone number exceeds the allowed length.",
    };
  }
  const value = !!PHONE_REGEX.test(phone as string);
  if (!value) {
    return {
      isError: true,
      errorMessage: "Please Enter Valid Phone Number.",
    };
  }

  return {
    isError: false,
    errorMessage: "",
  };
};
